import { Api } from "../../api";
import { cacheFunctionData } from "/utils";

export const fetchContacts = () => {
  return async (dispatch) => {
    const ITEMS = await cacheFunctionData(
      Api.location.getContacts,
      "contacts_10",
    );
    dispatch({ type: "SET_CONTACTS", payload: ITEMS });
  };
};

export const fetchContactsNew = (Redis = false, host = "", reset = false) => {
  return async (dispatch) => {
    const data = await Api.location.getContactsNew(Redis, reset);
    dispatch({
      type: "SET_CONTACTS_DATA",
      payload: data[host]
        ? {
            ...data[host],
            SHOPS: data[host].SHOPS.map((shop) => ({
              ...shop,
              HOST: host,
            })),
          }
        : data.farkop,
    });
  };
};
